import { motion } from "framer-motion";
import { BookOpenText, Phone, MapPin } from "lucide-react";
import { useLang } from "@/i18n";

const LABELS = {
  it: { menu: "Menu", call: "Chiama", where: "Dove", book: "Prenota ora" },
  en: { menu: "Menu", call: "Call", where: "Find us", book: "Book now" },
};

export function MobileActionBar() {
  const { lang } = useLang();
  const l = LABELS[lang] || LABELS.it;

  const item = "flex items-center justify-center text-[#0A0A0A] w-14";

  return (
    <motion.nav
      data-testid="mobile-action-bar"
      aria-label="Azioni rapide"
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-[#FAF9F6] border-t border-[#0A0A0A]/10 pb-[env(safe-area-inset-bottom)]"
      style={{ willChange: "transform" }}
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      transition={{ delay: 1.2, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="flex items-stretch justify-between gap-1 px-3 py-4">
        <a href="#menu" data-testid="mobilebar-menu" aria-label={l.menu} className={item}>
          <BookOpenText size={24} strokeWidth={1.6} />
        </a>
        <a href="tel:+393520981771" data-testid="mobilebar-call" aria-label={l.call} className={item}>
          <Phone size={24} strokeWidth={1.6} />
        </a>
        <a href="https://www.google.com/maps/search/?api=1&query=Funghetto+Roma+Via+Urbano+II+32+Roma"
           target="_blank" rel="noopener noreferrer" data-testid="mobilebar-where" aria-label={l.where} className={item}>
          <MapPin size={24} strokeWidth={1.6} />
        </a>
        <a href="#prenota" data-testid="mobilebar-book"
           className="flex-1 flex items-center justify-center whitespace-nowrap bg-[#6B1E33] text-[#FAF9F6] text-sm uppercase tracking-[0.2em] font-semibold px-3 active:bg-[#0A0A0A] transition-colors duration-200">
          {l.book}
        </a>
      </div>
    </motion.nav>
  );
}
